/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import React from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';

const QRCodeDisplay = ({ value, size = 160 }) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="p-3 bg-white border border-gray-200 rounded-xl inline-block">
        <QRCodeSVG value={value} size={size} level="M" includeMargin={false} />
      </div>
      <p className="text-xs text-gray-500">Scan to open on mobile</p>
    </div>
  );
};

export default QRCodeDisplay;

QRCodeDisplay.propTypes = {
  value: PropTypes.string,
  size: PropTypes.number,
};
